import cityzones from './cityzones.json'

if(!localStorage.getItem('cityzones'))
    localStorage.setItem('cityzones', JSON.stringify(cityzones))

